import { render } from "./AddLoaderModal.vue?vue&type=template&id=8b2250d4&scoped=true"
import script from "./AddLoaderModal.vue?vue&type=script&lang=js"
export * from "./AddLoaderModal.vue?vue&type=script&lang=js"

import "./AddLoaderModal.vue?vue&type=style&index=0&id=8b2250d4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b2250d4"]])

export default __exports__